<template>
  <div class="card shadow">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'brands' }">Brands</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Edit Brand
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-body" v-loading="loading">
      <el-tabs v-model="activePane" @tab-click="tabChange">
        <el-tab-pane label="Details" name="details">
          <brand-item-detail v-if="brand" :brand="brand"/>
        </el-tab-pane>
        <el-tab-pane label="Associated Products" name="related">
          <brand-item-association v-if="brand" :products="brand.products"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import BrandItemDetail from '@/components/Brand/Item/BrandItemDetail'
import BrandItemAssociation from '@/components/Brand/Item/BrandItemAssociation'

export default {
  components: {
    BrandItemDetail,
    BrandItemAssociation,
  },

  data() {
    return {
      loading: false,
      activePane: 'details',
      brand: null,
    }
  },

  async mounted() {
    this.loading = true

    try {
      var { data } = await this.$http.get(`/brands/${ this.$route.params.id }`)
    } catch(err) {
      this.$message.error(err.response.data.message)
      return false
    } finally {
      this.loading = false
    }

    this.brand = data
  },

  methods: {
    tabChange(tab, event) {
      this.activePane = tab.name
    },
  },
}
</script>
